import { useMemo } from "react";

export const useDefaultReturnUrl = (props: { returnUrl?: string }) => {
  return useMemo(() => {
    if (props.returnUrl) return props.returnUrl;
    if (typeof window !== "undefined") {
      return (
        window.location.pathname + window.location.search + window.location.hash
      );
    }
    return "/";
  }, [props.returnUrl]);
};
